module.exports = __webpack_public_path__ + "7d5f595684117cbb34821be2f24f26ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/foldermanager_header_desc.png
// module id = 67
// module chunks = 0 1 2 3 4